import { useEffect, useState } from 'react';
import { FrPageBody } from '../../fr-page-layout/fr-page-body';
import { FrEventDetailsTabsHeader } from './fr-event-details-tabs-header';
import {
    DEFAULT_EVENT_DETAILS_TAB,
    EVENT_DETAILS_TAB_CONFIG,
    FR_TAB_COMPONENTS,
} from '../constants';
import { FrEventDetailsTab } from '../types';

export default function FrEventDetailsTabs({
    eventId,
    requestedTab,
}: {
    eventId: number;
    requestedTab?: FrEventDetailsTab;
}) {
    const [activeTab, setActiveTab] = useState<FrEventDetailsTab>(DEFAULT_EVENT_DETAILS_TAB);

    useEffect(() => {
        setActiveTab(requestedTab ?? DEFAULT_EVENT_DETAILS_TAB);
    }, [eventId, requestedTab]);

    const TabComponent = activeTab ? FR_TAB_COMPONENTS[activeTab] : undefined;

    return (
        <FrPageBody>
            <FrEventDetailsTabsHeader
                activeTab={activeTab}
                tabConfigs={EVENT_DETAILS_TAB_CONFIG}
                eventId={eventId}
            />
            {!!TabComponent && <TabComponent />}
        </FrPageBody>
    );
}
